import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { DatevRechercheResult } from 'src/modules/enaio/shared/DatevRechercheResult';
import { EnaioHelper } from 'src/modules/enaio/shared/enaio-helper.model';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { DhTools } from '../../models/dh-tools.model';
import { TableCellButton } from 'src/modules/sm-base/models/table-cell-button.model';
import { TableCellEvent } from 'src/modules/sm-base/models/table-cell-event.model';

@Component({
  selector: 'app-datev-invoice-search',
  templateUrl: './datev-invoice-search.component.html',
  styleUrls: ['./datev-invoice-search.component.scss']
})
export class DatevInvoiceSearchComponent extends ComponentView {

    _Utils = Utils;

    formFilter: FrontendFormDefinition;
    result: DatevRechercheResult[];
    table: TableData;

    async initParams(): Promise<boolean> {
        this.formFilter = new FrontendFormDefinition([
            new FrontendFieldDefinition("documentNumber", "Rechnungsnummer", FrontendFieldType.text),
            new FrontendFieldDefinition("amount", "Betrag", FrontendFieldType.text),
            new FrontendFieldDefinition("workflowId", "enaio Workflow ID", FrontendFieldType.text),
            new FrontendFieldDefinition("firstYear", "Startjahr", FrontendFieldType.int, { value: new Date().getFullYear() - 1 })
        ]);
        return Promise.resolve(true);
    }

    async search(): Promise<void> {
        this.result = await DhTools.backendCall("api/datev/recherche", Utils.objectRemoveNullValues({
            documentNumber: this.formFilter.getValue("documentNumber") != "" ? this.formFilter.getValue("documentNumber") : null,
            amount: this.formFilter.getValue("amount") != "" ? this.formFilter.getValue("amount") : null,
            workflowId: this.formFilter.getValue("workflowId") != "" ? this.formFilter.getValue("workflowId") : null,
            fromDate: Utils.toNumber(this.formFilter.getValue("firstYear")) > 0 ? new Date(Utils.toNumber(this.formFilter.getValue("firstYear")), 0, 0) : null
        })).list(DatevRechercheResult);

        this.table = new TableData([
            new TableColumn("action", "", TableCellType.button, { autoWidth: 2 }),
            new TableColumn("type", "Typ", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("id", "ID", TableCellType.text, { autoWidth: 15 }),
            new TableColumn("date", "Datum", TableCellType.date, { autoWidth: 1 }),
            new TableColumn("documentNumber", "Rechnungsnummer", TableCellType.text, { autoWidth: 20 }),
            new TableColumn("amount", "Betrag", TableCellType.decimal, { autoWidth: 8 }),
            new TableColumn("accountNumber", "Kontonummer", TableCellType.text, { autoWidth: 10 }),
            new TableColumn("contraAccountNumber", "Gegenkontonummer", TableCellType.text, { autoWidth: 10 })
        ], this.result.map(item => new TableRow("", item, {
                action: [new TableCellButton("details", "fas fa-eye", "Details"), new TableCellButton("restore", "fas fa-check", "Wiederherstellen", item.id?.endsWith('.json'))],
                type: EnaioHelper.datevRechercheTypeToString(item.type),
                id: item.id,
                date: item.date,
                documentNumber: item.documentNumber,
                amount: item.amount,
                accountNumber: item.accountNumber,
                contraAccountNumber: item.contraAccountNumber
            })));
    }

    async restore(item: DatevRechercheResult): Promise<void> {
        await DhTools.backendCall("api/datev/restore", { fileName: item.id}).getString();
    }

    async clickCell(event: TableCellEvent): Promise<void> {
        if (event.isButton("details", "action")) {
            this.app.messageDialog.textArea("Details", Utils.toJson((event.row.raw as DatevRechercheResult).data, true));
        }
        else if (event.isButton("restore", "action")) {
            await this.restore(event.row.raw as DatevRechercheResult);
        }
    }
}
